(function(angular){
	'use strict';

	angular.module('minInvestmentAmountModule', [
		'BaseConfig'
	]);
})(window.angular);